import { useQuery } from "@tanstack/react-query";
import { getPeopleCulture } from "../api/cmsApi";
import { cmsKeys } from "../api/cmsKeys";

// Lectura compartida del CMS: las cuatro pages y LinkUtils consumen el mismo
// query, así una sola request alimenta a todas (cache por queryKey).
export const usePeopleCulture = () =>
  useQuery({
    queryKey: cmsKeys.peopleCulture(),
    queryFn: getPeopleCulture,
  });
